import { render, staticRenderFns } from "./ComBreadcrumb.vue?vue&type=template&id=6aab637a"
import script from "./ComBreadcrumb.vue?vue&type=script&lang=js"
export * from "./ComBreadcrumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports